export const IronRV = window.IronRV;    

const TEXT_IRONSOURCE = 'Ironsource: ';

export function initIronSource(eventsArr) {

  // CONFIGURATION

  const params = {
      applicationKey: "13yexm7t",
      applicationUserId: guid(),
      closeButtonShowTime :30
    };

  // INITIALIZE IRONSOURCE
  const ironRV = IronRV.getInstance(params);
    
  // EVENT LISTENERS
  initEventListeners(eventsArr, ironRV);

  return ironRV;
}

function initEventListeners(eventsArr, ironRV) {
  eventsArr.forEach(evt=>{
    if (evt.callback !== undefined && evt.callback !== null) {
      console.log(TEXT_IRONSOURCE, evt);
      ironRV.addListener(evt.name, ()=>{
        console.log(TEXT_IRONSOURCE, evt.name);
        evt.callback({ironRV, name: evt.name});
      });
    }
  });
}

// USER INTERFACE

export function showRewardVideo(ironRV) {
  console.log(TEXT_IRONSOURCE, "Opt-In call to action button Clicked");
  ironRV.show();
  disableOffer();
}

export function hideOffer() {
      console.log(TEXT_IRONSOURCE, "Hide call to action button UI");
}

export function showOffer() {
      console.log(TEXT_IRONSOURCE, "Show call to action button UI");
}

export function disableOffer() {
      console.log(TEXT_IRONSOURCE, "Disable call to action button but keep it Shown in UI");
}

export function adBlockerPopup(ironRV) {
  ironRV.showAdBlockMessage();
  console.log(TEXT_IRONSOURCE, "Ad Blocker Detected");
  // hideOffer();
}

function	guid() {

    const nav = window.navigator;
		const screen = window.screen;
		const ga = document.cookie && document.cookie.split(';').filter((val)=>val.indexOf('_ga=')===0);
		const gauid = ga.length===1?ga[0].split('=')[1]:'';

		let guid = nav.mimeTypes.length;

    guid += nav.userAgent.replace(/\D+/g, '');
    guid += nav.plugins.length;
    guid += screen.height || '';
    guid += screen.width || '';
    guid += screen.pixelDepth || '';


    return gauid + guid;
	};